function Article2 () {
    return <p> ceci est l'article 2</p>
}
export default Article2